<twc-toolbar *ngIf="toolbarDefinition" class="toolbar" [orientation]="toolbarDefinition.orientation" #twcToolbar
    (optionSelected)="onSelectOption($event)">
    <ng-container *ngFor="let option of toolbarDefinition.options">
        <twc-toolbar-option *ngIf="option.direction && option.childToolbar?.options?.length" [iconShape]="option.icon"
            [disabled]="option.disabled ?? false" [toolbarDirection]="option.direction" [data]="option.data"
            [twcTooltip]="option.tooltip | translate" [position]="option.placementTooltip"
            [ngClass]="{'selected': option.selected}" (click)="collapseOthersToolbars()" class="{{option.className}}">
            <twc-toolbar *ngIf="option.childToolbar" class="toolbar" [orientation]="option.childToolbar.orientation"
                (optionSelected)="onSelectOption($event)">
                <twc-toolbar-option *ngFor="let optionLevel2 of option.childToolbar.options"
                    [iconShape]="optionLevel2.icon" [twcTooltip]="optionLevel2.tooltip | translate"
                    [position]="optionLevel2.placementTooltip" [data]="optionLevel2.data"
                    [ngClass]="{'selected': optionLevel2.selected}" [disabled]="optionLevel2.disabled ?? false">
                </twc-toolbar-option>
            </twc-toolbar>
        </twc-toolbar-option>
        <twc-toolbar-option *ngIf="!option.direction" [iconShape]="option.icon" [data]="option.data"
            [twcTooltip]="option.tooltip | translate" [position]="option.placementTooltip"
            [disabled]="option.disabled ?? false" [ngClass]="{'selected': option.selected}"
            class="{{option.className}}">
        </twc-toolbar-option>
        <twc-popover cwPopoverFocusOutClose *ngIf="option.childPanel" [attr.data-name]="option.childPanel.name"
            [width]="option.childPanel.width ?? defaultPanelWidth"
            [maxWidth]="option.childPanel.maxWidth ?? defaultPanelWidth"
            [trigger]="option.childPanel.trigger ?? defaultPanelTrigger" [closeButton]="false"
            [position]="option.childPanel.placement ?? defaultPanelPlacement"
            (onTrigger)="updatePanelStatus(option.childPanel.name, $event)">
            <div twcPopoverBody>
                <ng-container [ngTemplateOutlet]="getPanelByName(option.childPanel.name)"></ng-container>
            </div>
            <twc-toolbar-option [iconShape]="option.icon" [data]="option.data" [twcTooltip]="option.tooltip | translate"
                [position]="option.placementTooltip" [disabled]="option.disabled ?? false"
                [ngClass]="{'selected': option.selected}" class="{{option.className}}"
                (click)="openPanel(option); collapseOthersToolbars(true)">
            </twc-toolbar-option>
        </twc-popover>
    </ng-container>
</twc-toolbar>